module.exports = __webpack_public_path__ + "img/matrimonio.654e1102.png";